/**
 * Default DSL scripts per multi-symbol analysis type.
 * Used when the user does not customize the script (preset mode).
 */

export const DEFAULT_DSL_BY_TYPE: Record<string, string> = {
  comparison: `# Default: Symbol comparison
# The 'symbol' column is automatically available

stats by symbol:
  count(*) as total_bars
  avg(close) as avg_price
  stddev(close) as volatility
  min(close) as min_price
  max(close) as max_price

daily_return = (close - close[1]) / close[1] * 100
stats by symbol:
  avg(daily_return) as avg_return
  stddev(daily_return) as volatility
  percent(daily_return > 0) as win_rate

output stats`,

  correlation: `# Default: Correlation-style metrics by symbol
# The 'symbol' column is automatically available

stats by symbol:
  count(*) as n
  avg(close) as avg_close
  stddev(close) as vol

daily_return = (close - close[1]) / close[1] * 100
stats by symbol:
  avg(daily_return) as avg_return
  stddev(daily_return) as volatility

output stats`,

  spread: `# Default: Spread / pairs-style stats by symbol
# The 'symbol' column is automatically available

stats by symbol:
  count(*) as bars
  avg(close) as avg_price
  stddev(close) as volatility

daily_return = (close - close[1]) / close[1] * 100
stats by symbol:
  avg(daily_return) as avg_return
  stddev(daily_return) as vol

output stats`,

  basket: `# Default: Basket / portfolio-style by symbol
# The 'symbol' column is automatically available

stats by symbol:
  count(*) as total_bars
  avg(close) as avg_price
  stddev(close) as volatility

daily_return = (close - close[1]) / close[1] * 100
stats by symbol:
  avg(daily_return) as avg_return
  stddev(daily_return) as volatility
  percent(daily_return > 0) as win_rate

output stats`,

  custom: `# Custom analysis – edit this script as needed
# The 'symbol' column is automatically available

stats by symbol:
  count(*) as total_bars
  avg(close) as avg_price
  stddev(close) as volatility

output stats`,
}

export function getDefaultDslForType(analysisType: string): string {
  return DEFAULT_DSL_BY_TYPE[analysisType] ?? DEFAULT_DSL_BY_TYPE.custom
}
